import { IOTV_LCD_GatewayData, MapLike, StateSnapshot, Position } from '@iotv/iotv-v3-types'
import { BBox, Feature, GeoJsonProperties, GeoJsonTypes, Point } from 'geojson'
import { GeoJsonDatastoreObject, IGeoJsonPoint } from '../../types/GeoTypes'
import { HistoryStore } from '../constructs/HistoryStore'
import { enumerable } from '../constructs/enumerableDecorator'
import { GeofencePointsType, UserAttributeDefs } from '../../types/ModelTypes'
import { GeoModelCommon } from './GeoModelCommon'
const debug = process.env.REACT_APP_DEBUG && false

/**
 * GeoPoint Point
 * For some reason it was thought a great idea not to name this class the same as the typeName (RE)
 */

const typeName = 'Point'

interface IGoefence {
  points: GeofencePointsType[]
}

type UpdateGatewayStatisticsInput = {
  gatewaySk: string
  gatewayData: IOTV_LCD_GatewayData
}

class GeoPoint extends GeoModelCommon implements IGeoJsonPoint {
  constructor({ gatewayStatistics, ...ob }: GeoJsonDatastoreObject<Point>) {
    super({ ...ob, type: ob.type ?? typeName })

    if (gatewayStatistics) {
      Object.entries(gatewayStatistics).forEach(([k, stats]) => {
        const historyStore = new HistoryStore(stats)
        historyStore.setAutoTrim(true)
        historyStore.setMaxLength(10)
        this.gatewayStatistics[k] = historyStore
      })
    }
    this.dsk = ob.id
    debug && console.log('GeoPoint from Location, Model Common', this)
  }
  name?: string
  bbox?: BBox
  geoJson?: Feature<Point, GeoJsonProperties>

  gatewayStatistics: MapLike<HistoryStore> = {}
  ttl?: number | undefined
  dataCount?: number | undefined
  type: GeoJsonTypes = typeName

  get position() {
    return this.location
  }

  set position(position: Position | undefined) {
    this.location = position
  }

  @enumerable(false) updateGatewayStatistics({ gatewaySk, gatewayData }: UpdateGatewayStatisticsInput) {
    if (!this.gatewayStatistics[gatewaySk]) {
      this.gatewayStatistics[gatewaySk] = new HistoryStore()
    }

    const { timestamp, ...data } = gatewayData

    const stateSnapshot: StateSnapshot<number> = {
      timestamp: timestamp ?? Date.now(),
      state: {},
    }

    const { rssi, snr } = gatewayData

    stateSnapshot.state = Object.fromEntries(Object.entries({ rssi, snr }).filter(([k, v]) => typeof v === 'number')) as MapLike<number>

    this.gatewayStatistics[gatewaySk].push(stateSnapshot)
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
    }
  }
}

export { GeoPoint }
